import React from "react";

const KPK = () => {
  return (
    <>
      <h1>Work in Progress</h1>
    </>
  );
};

export default KPK;
